module.exports = __webpack_public_path__ + "static/img/12.0290fb2d.png";